import React, { useState } from 'react';
import { classNames } from '../helpers/functions';

export default ({
	initialTab,
	activeTab,
	tabs = [],
	children,
	showZero,
	className,
	containerClassName,
	size,
	onChange,
}) => {
	const [active, setActive] = useState(
		initialTab || activeTab || (tabs?.length ? tabs[0].key : null)
	);
	return (
		<div className={containerClassName}>
			<div className={classNames('border-b border-gray-200 mb-4', className)}>
				<nav
					className={classNames(
						'-mb-px flex',
						size === 'xs' ? 'space-x-6' : 'space-x-8'
					)}
					aria-label="Tabs"
				>
					{tabs.map((tab, i) => {
						const current = tab.key === active;
						const count = tab?.count || 0;
						const showTabZero =
							typeof tab.showZero !== 'undefined' ? tab.showZero : showZero;
						return (
							<div
								key={tab.name}
								onClick={() => {
									if (tab?.disabled) {
										return;
									}

									if (typeof tab.onClick === 'function') {
										tab.onClick(tab.key);
									}
									setActive(tab?.key);

									if (typeof onChange === 'function') {
										onChange(tab?.key);
									}
								}}
								className={classNames(
									current
										? 'border-indigo-500 text-indigo-600'
										: 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700',
									'flex whitespace-nowrap border-b-2 items-center',
									tab?.disabled
										? 'text-gray-300 hover:border-transparent hover:text-gray-300'
										: 'cursor-pointer',
									size === 'xs'
										? 'text-xxs py-2 px-1'
										: 'py-4 px-1 text-xs font-medium'
								)}
								aria-current={current ? 'page' : undefined}
							>
								{tab.name}
								{showTabZero || count ? (
									<span
										className={classNames(
											current
												? 'bg-indigo-100 text-indigo-600'
												: 'bg-gray-100 text-gray-900',
											'ml-3 hidden rounded-full py-0.5 px-2.5 text-xxs font-medium md:inline-block'
										)}
									>
										{count}
									</span>
								) : null}
							</div>
						);
					})}
				</nav>
			</div>
			{children && children(active)}
		</div>
	);
};
